import {
  bindHandoffActions,
  normalizeHandoffActions,
  renderHandoffActionsEmbed
} from './capability-block-view-renderer.js'

function normalizeFieldSummaryUi(result) {
  if (!result || typeof result !== 'object') return null

  var ui = result.ui || result.fieldSummaryUi || result.dictationSummaryUi || null
  if (!ui || typeof ui !== 'object') return null

  var type = String(ui.type || '').toLowerCase()
  if (type !== 'field-summary' && type !== 'field-summary-ui' && type !== 'dictation-summary') return null

  var fields = Array.isArray(ui.fields)
    ? ui.fields.map(function (field) {
      if (!field || typeof field !== 'object') return null
      var label = String(field.label || '').trim()
      var value = String(field.value || '').trim()
      return label ? { label: label, value: value || '—' } : null
    }).filter(Boolean)
    : []

  if (!fields.length) return null

  var handoffActions = normalizeHandoffActions(ui.handoffActions || result.handoffActions)
  return {
    type: 'field-summary',
    title: String(ui.title || 'Résumé').trim(),
    fields: fields,
    ...(handoffActions.length ? { handoffActions: handoffActions } : {})
  }
}

function bindFieldSummaryUi(root, ui, handlers) {
  bindHandoffActions(root, ui && ui.handoffActions, handlers)
}

function renderFieldSummaryUi(ui) {
  return (
    '<div class="wc-field-summary-ui" data-ds-view="field-summary-ui">' +
      (ui.title ? '<div class="wc-field-summary-title">' + escapeHtml(ui.title) + '</div>' : '') +
      '<div class="wc-field-summary-fields">' +
        ui.fields.map(function (field) {
          return (
            '<div class="wc-field-summary-row">' +
              '<div class="wc-field-summary-label">' + escapeHtml(field.label) + '</div>' +
              '<div class="wc-field-summary-value">' + renderFieldValue(field.value) + '</div>' +
            '</div>'
          )
        }).join('') +
      '</div>' +
      renderHandoffActionsEmbed(ui.handoffActions) +
    '</div>'
  )
}

function renderFieldValue(value) {
  return escapeHtml(value).replace(/\r?\n/g, '<br>')
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export { bindFieldSummaryUi, normalizeFieldSummaryUi, renderFieldSummaryUi }
